package com.eladfinish.bible.contest.screens.search.ui.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.screens.search.menu.SearchToolbarId
import com.eladfinish.bible.contest.screens.search.model.SearchMode
import com.eladfinish.bible.contest.screens.search.model.SearchPlace
import com.eladfinish.bible.contest.screens.search.mvi.SearchState
import com.eladfinish.bible.contest.ui.components.toolbar.UpdateToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.SubMenuContent
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionVisibility
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun SearchMenuSync(
    state: SearchState,
) {
    UpdateToolbarConfiguration<SearchToolbarId>(
        update = {
            copy(
                actions = actions
                    .map { action ->
                        action.syncWithState(state)
                    }
                    .toImmutableList(),
            )
        },
        state.onlyQri,
        state.searchMode,
        state.searchPlace,
        state.withNikud,
        state.withTeamim,
        state.isSearchSuggestionsEnabled,
    )
}

@Suppress("UNCHECKED_CAST")
private fun ToolbarActionConfig<SearchToolbarId>.syncWithState(
    state: SearchState,
): ToolbarActionConfig<SearchToolbarId> =
    when (this) {
        is ToolbarActionConfig.TextActionRes ->
            when (id) {
                SearchToolbarId.POPULAR_SEARCHES ->
                    copy(
                        visibility = if (state.isSearchSuggestionsEnabled) {
                            ToolbarActionVisibility.Always
                        } else {
                            ToolbarActionVisibility.Never
                        },
                    )

                else -> this
            }

        is ToolbarActionConfig.CheckboxActionRes ->
            when (id) {
                SearchToolbarId.ONLY_QRI ->
                    copy(checked = state.onlyQri)

                SearchToolbarId.TEXT_WITH_NIKUD ->
                    copy(checked = state.withNikud)

                SearchToolbarId.TEXT_WITH_TEAMIM ->
                    copy(checked = state.withTeamim)

                else -> this
            }

        is ToolbarActionConfig.SubMenu ->
            when (id) {
                SearchToolbarId.SEARCH_MODE_MENU -> {
                    val radioSubMenu =
                        content as SubMenuContent.RadioSubMenu<SearchToolbarId, SearchMode>

                    copy(
                        content = radioSubMenu.copy(
                            selected = state.searchMode,
                        ),
                    )
                }

                SearchToolbarId.WHERE_TO_SEARCH_MENU -> {
                    val radioSubMenu =
                        content as SubMenuContent.RadioSubMenu<SearchToolbarId, SearchPlace>

                    copy(
                        content = radioSubMenu.copy(
                            selected = state.searchPlace,
                        ),
                    )
                }

                else -> this
            }

        else -> this
    }
